import axios from "axios";


const BaseHandler = axios.create({
    // baseURL:"http://192.168.0.100:5000/"
    baseURL:"https://hafeezatifbackend.vercel.app/"
})

let GetApi = (endPoint) =>{
    return BaseHandler.get(endPoint)
}

let PostApi = (endPoint,body) =>{
    return BaseHandler.post(`${endPoint}`,body)
}

let PutApi = (endPoint,id,body) =>{
    return BaseHandler.put(`${endPoint}/${id}`,body)
}


const DeleteApi = (endpoint,id,body) =>{
    return BaseHandler.delete(`${endpoint}/${id}`,body)
}

export {GetApi,PostApi,PutApi,DeleteApi}
